import { useState } from "react";
import { CustomDialog } from "../../../../../../components/dialog/v1/CustomDialog";
import { CustomLabelInput } from "../../../../../../components/input/CustomLabelInput";
import * as St from './index.styled';
import CustomBlockButton from "../../../../../../components/button/CustomBlockButton";

export function SettingValueModal({
    open,
    onClose,
    currentPalletWidth,
    currentPalletDepth,
    currentPalletHeight,
    currentMaxCBMOfExtraItems,
    onSave
}) {
    const [palletWidth, setPalletWidth] = useState(currentPalletWidth);
    const [palletDepth, setPalletDepth] = useState(currentPalletDepth);
    const [palletHeight, setPalletHeight] = useState(currentPalletHeight);
    const [maxCBMOfExtraItems, setMaxCBMOfExtraItems] = useState(currentMaxCBMOfExtraItems);

    const handleChangePalletWidth = (e) => {
        const value = e.target.value;
        setPalletWidth(value);
    }
    const handleChangePalletDepth = (e) => {
        const value = e.target.value;
        setPalletDepth(value);
    }
    const handleChangePalletHeight = (e) => {
        const value = e.target.value;
        setPalletHeight(value);
    }
    const handleChangeMaxCBMOfExtraItems = (e) => {
        const value = e.target.value;
        setMaxCBMOfExtraItems(value);
    }

    const handleSaveSettingValue = (e) => {
        e.preventDefault();

        onSave({
            palletWidth: Number(palletWidth),
            palletDepth: Number(palletDepth),
            palletHeight: Number(palletHeight),
            maxCBMOfExtraItems: Number(maxCBMOfExtraItems),
        })
        onClose();
    }
    return (
        <>
            <CustomDialog
                open={open}
                onClose={() => onClose()}
            >
                <St.Header.Container>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>세팅값</CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={() => onClose()} />
                    </CustomDialog.Header>
                </St.Header.Container>
                <form onSubmit={handleSaveSettingValue}>
                    <St.Body.Container>
                        <St.Body.FormWrapper>
                            <CustomLabelInput>
                                <CustomLabelInput.Input
                                    type='number'
                                    value={palletWidth || ''}
                                    onChange={handleChangePalletWidth}
                                />
                                <CustomLabelInput.Label>파레트 너비(mm)</CustomLabelInput.Label>
                            </CustomLabelInput>
                            <CustomLabelInput>
                                <CustomLabelInput.Input
                                    type='number'
                                    value={palletDepth || ''}
                                    onChange={handleChangePalletDepth}
                                />
                                <CustomLabelInput.Label>파레트 깊이(mm)</CustomLabelInput.Label>
                            </CustomLabelInput>
                            <CustomLabelInput>
                                <CustomLabelInput.Input
                                    type='number'
                                    value={palletHeight || ''}
                                    onChange={handleChangePalletHeight}
                                />
                                <CustomLabelInput.Label>파레트 높이(mm)</CustomLabelInput.Label>
                            </CustomLabelInput>
                            <CustomLabelInput>
                                <CustomLabelInput.Input
                                    type='number'
                                    value={maxCBMOfExtraItems || ''}
                                    onChange={handleChangeMaxCBMOfExtraItems}
                                />
                                <CustomLabelInput.Label>단독 파레트 사용 최소CBM(m^3)</CustomLabelInput.Label>
                            </CustomLabelInput>
                        </St.Body.FormWrapper>
                        <St.Body.ButtonWrapper>
                            <CustomBlockButton
                                type='submit'
                            >
                                저장
                            </CustomBlockButton>
                        </St.Body.ButtonWrapper>
                    </St.Body.Container>
                </form>
            </CustomDialog>
        </>
    );
}
